import axios from "axios";
import qs from "qs";
import { Message } from "element-ui";

const isProduction = process.env.NODE_ENV === 'production';
axios.defaults.baseURL = isProduction ? 'https://dsc.asec.cloud' : '/';
// axios.defaults.baseURL = isProduction ? 'https://ask.sydcy.cn' : '/';
axios.defaults.timeout = 100000;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

// 跳转登录辅助函数
function redirectToLogin() {
  const path = window.location.pathname + window.location.hash;
  if (path === '/login' || path === '#/login') return;
  window.location.href = '#/login';
}


// 请求拦截器
axios.interceptors.request.use(
  config => {

    //无需token的接口
    const whiteList = [
      '/api/login/userlogin',
       '/api/login/danye'
    ];
    const needToken = !whiteList.some(url => config.url.includes(url));
    if (needToken) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['TOKEN'] = token;
      }
    }

    // 如果数据是 FormData，则不做任何转换，让浏览器自动设置 Content-Type
    if (config.data instanceof FormData) {
      // 删除手动设置的 Content-Type，让浏览器自动生成包含 boundary 的 header
      delete config.headers['Content-Type'];
      return config;
    }

    if (config.method === 'post' && config.data && typeof config.data === 'object' && !config.headers['Content-Type']) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 1) return res;
    
    Message.error(res.msg || '请求失败');
    console.log(res,111)
    if (res.code === 401) {
      localStorage.removeItem('token');
      redirectToLogin();
      return
    }
    return Promise.reject(res);
  },
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // 避免在登录页重复提示
      if (!window.location.pathname.includes('/login') && !window.location.hash.includes('/login')) {
        Message.error('请先登录');
      }
      redirectToLogin();
      return
    } else {
      // 其他错误处理...
    }
    return Promise.reject(error);
  }
);

export default {
  get(url, params) { return axios.get(url, { params }); },
  post(url, data, config = {}) { return axios.post(url, data, config); },
  upload(url, formData) {
    return axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }
};